import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule, PercentPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';
import { SharedFeatureComponentsModule } from '@digilize/shared/feature/components/src';
import { SharedFeatureModulesLoginModule } from '@digilize/shared/feature/modules/auth/src';
import { LangComponentsModule } from '@digilize/shared/feature/modules/i18n/src';
import { SharedUiComponentsModule } from '@digilize/shared/ui/components/src';
import { SharedUiMaterialModule } from '@digilize/shared/ui/material/src';
import { SharedUtilsDirectivesModule } from '@digilize/shared/utils/directives/src';
import { SharedUtilsPipesModule } from '@digilize/shared/utils/pipes/src';
import { HighchartsChartModule } from 'highcharts-angular';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import { AccordionNavComponent } from './accordion-nav/accordion-nav.component';
import { ChartsGroupComponent } from './charts-group/charts-group.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { ResearchChartComponent } from './research-chart/research-chart.component';
import { ResearchQueryTableComponent } from './research-query-table/research-query-table.component';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [
    NavBarComponent,
    ChartsGroupComponent,
    AccordionNavComponent,
    ResearchQueryTableComponent,
    ResearchChartComponent,
  ],
  imports: [
    CommonModule,
    LazyLoadImageModule,
    TranslocoModule,
    SharedUiMaterialModule,
    CdkAccordionModule,
    SharedUiComponentsModule,
    ReactiveFormsModule,
    SharedUtilsPipesModule,
    InlineSVGModule,
    RouterModule,
    SharedFeatureComponentsModule,
    SharedUtilsDirectivesModule,
    MatExpansionModule,
    HighchartsChartModule,
    LangComponentsModule,
    SharedUtilsPipesModule,
    SharedFeatureModulesLoginModule,
  ],
  exports: [
    CommonModule,
    SharedUiMaterialModule,
    LazyLoadImageModule,
    TranslocoModule,
    SharedUiMaterialModule,
    CdkAccordionModule,
    SharedUiComponentsModule,
    ReactiveFormsModule,
    SharedUtilsPipesModule,
    InlineSVGModule,
    RouterModule,
    NavBarComponent,
    ChartsGroupComponent,
    AccordionNavComponent,
    ResearchQueryTableComponent,
    ResearchChartComponent,
  ],
  providers: [PercentPipe],
})
export class SharedModule {}
